var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fc-org-select" },
    [
      _c("div", { staticClass: "tags" }, [
        _c(
          "div",
          { staticClass: "input-box as-input" },
          [
            _vm._l(_vm.selectedData, function(item) {
              return _c(
                "el-tag",
                {
                  key: item.id,
                  staticClass: "org-tag",
                  attrs: { closable: "" },
                  on: {
                    close: function($event) {
                      return _vm.onClose(item)
                    }
                  }
                },
                [_vm._v(" " + _vm._s(item.label) + " ")]
              )
            }),
            _c(
              "el-tag",
              {
                staticClass: "org-tag",
                attrs: { type: "success" },
                on: {
                  click: function($event) {
                    _vm.dialogTableVisible = true
                  }
                }
              },
              [_vm._v(" + 添加人员 ")]
            )
          ],
          2
        )
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "组织机构",
            visible: _vm.dialogTableVisible,
            width: "40%",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogTableVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { "text-align": "center" } },
            [
              _c("tree-transfer", {
                attrs: { data: _vm.list, filterable: "" },
                model: {
                  value: _vm.value,
                  callback: function($$v) {
                    _vm.value = $$v
                  },
                  expression: "value"
                }
              }),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.dialogTableVisible = false
                        }
                      }
                    },
                    [_vm._v("取 消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.confirmSelect }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }